// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_kz-0";
export var discountCodeInput = "_kz-1";